import React from 'react';
import ReactDOM from 'react-dom';
import { GlobalStyle } from './app/genericComponents/globalStyles';
import "antd/dist/antd.css";
import './assets/languaje/index';
import Home from './app/main/screens/Home';

ReactDOM.render(
  <>
    <GlobalStyle />
    <Home />
  </>,
  document.getElementById(window.targetDiv||'root')
);